import React from 'react';
import './book.scss';

class BookPage extends React.Component {
	constructor(props){
		super(props);
		this.state = {
		};
	}

	render (){
		return (
			<div id="book">
				<h2>説明書</h2>
				<h3>どんなアソビ？</h3>
				<div className="text">
					<p>革命前夜の首都に仲間を潜入させるのが貴方（コリー）の仕事です。</p>
					<p>先に首都に潜入している相棒（マリー）が首都の警備状況を知らせてくれますので、無事に潜入できる仲間を選びましょう。</p>
					<ul>
						<li>制限時間内に一人でも多くの仲間を通過させて下さい。</li>
						<li>仲間が一人でも逮捕されたらゲームオーバーです。</li>
					</ul>
				</div>
				<h3>進め方</h3>
				<div className="text">
					<p>貴方の前に仲間が一人ずつ登場します。仲間のプロフィールが表示されますので、首都に潜入できそうなら「GO」を、そうでなければ「STOP」を選んで下さい。</p>
					<p>首都で何らかの禁止令が出るとマリーが教えてくれます。例えばギギドド街の出身者が問答無用に逮捕される「ギギドド街禁止令」などです。「ギギドド街禁止令」が出ている間は、ギギドド街出身の仲間を首都に潜入させてはいけません。</p>
					<ul>
						<li>残り時間を示す砂時計（右上）は、マリーからの通信がくる数秒前に色が変わります。</li>
						<li>禁止令は撤回される場合もあります。</li>
					</ul>
				</div>
				<h3>ＧＯ</h3>
				<div className="text">
					<p>何も問題がないようであれば、「GO」をタップして仲間を潜入させましょう。</p>
				</div>
				<h3>ＳＴＯＰ</h3>
				<div className="text">
					<p>「STOP」する時には最低1か所はバツをつける必要があります。例えば出身地に問題がある場合には、出身地をタップしてバツをつけてから「STOP」して下さい。</p>
					<p>「STOP」された仲間は引き下がり、次の仲間が登場します。</p>
					<ul>
						<li>バツをつける箇所を間違えても特にペナルティはありません</li>
						<li>引き下がった仲間は、あとでまた登場します。</li>
					</ul>
				</div>
				<br/><br/><br/><br/>
				<div className="arrow"
					onClick={()=>this.close()}
				>
					<p>
						<i className="fas fa-check"></i>
					</p>
				</div>
			</div>
		)
	}

	close (){
		this.props.close();
	}
}

export default BookPage;